import React from "react";
import Moment from "react-moment";
import { PaymentDetailsPaypal } from "../model/OrderDetails";
import { PriceView } from "../components/common/Price.view";
import { User } from "../user/User";
import { ApiLinkedButtonV3 } from "../components/common/Form/ApiLinked.button.V3";
import { PaymentApi } from "./Payment.Api";
import { reloadWindowPromise } from "../components/common/reloadCallback";

interface PaymentPaypalComponentProps {
  paymentDetails: PaymentDetailsPaypal;
  liu?: User;
}

export class PaymentPaypalComponent extends React.Component<PaymentPaypalComponentProps> {
  render() {
    return (
      <>
        <div className="PaymentPaypalComponent">
          <div className="card-body p-0">
            {this.props.paymentDetails.paypalOrderId && (
              <div className="col no-gutters align-items-center">
                <span className="font-weight-bold">Paypal Order ID : </span>
                <span className="text-xs mb-1">
                  {this.props.paymentDetails.paypalOrderId}
                </span>
              </div>
            )}
            {this.props.paymentDetails.paymentDate && (
              <div className="col no-gutters align-items-center">
                <span className="font-weight-bold">Payment Date: </span>
                <span className=" text-xs mb-1">
                  <Moment format="DD-MM-YYYY">
                    {this.props.paymentDetails.paymentDate}
                  </Moment>
                </span>
              </div>
            )}
            <div className="col no-gutters align-items-center">
              <span className="font-weight-bold">Payment Status: </span>
              {this.props.paymentDetails.paymentStatus}
            </div>
            <div className="col no-gutters align-items-center">
              <span className="font-weight-bold">Payment Method: </span>

              <span className="text-xs mb-1">
                {this.props.paymentDetails.paymentMethod}
              </span>
            </div>

            {this.props.paymentDetails.paymentPrice && (
              <div className="col no-gutters align-items-center">
                <span className="font-weight-bold">Payment Amount: </span>

                <span className="text-xs mb-1">
                  <PriceView
                    price={this.props.paymentDetails.paymentPrice}
                    showFree={true}
                  />
                </span>
              </div>
            )}

            {this.props.paymentDetails.adminConfirmedAt &&
              this.props.liu?.basicDetails.isAdmin && (
                <div className="alert alert-info mt-2 mb-1 p-2" role="alert">
                  <strong>⚠️ Admin confirmed</strong> — This payment was
                  manually marked as paid by an admin. PayPal did not confirm
                  successful capture at the time of confirmation.
                </div>
              )}

            {this.props.liu?.basicDetails.isAdmin && (
              <>
                <ApiLinkedButtonV3
                  formModalSize="md"
                  initialValues={{}}
                  apiFormBody={
                    <>
                      <h6>Are you sure?</h6>
                      <div className="alert alert-warning mt-2" role="alert">
                        This is an irreversible action.
                      </div>
                    </>
                  }
                  buttonProps={{
                    content: {
                      normal: <>Mark as Paid</>,
                    },
                  }}
                  api={PaymentApi.markPaypalPaymentSuccess(
                    this.props.paymentDetails.paypalOrderId
                  )}
                  successCallback={reloadWindowPromise}
                  uniqueKey={
                    "payment-" +
                    this.props.paymentDetails.paypalOrderId +
                    "-mark-complete"
                  }
                />
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

